var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#efcc68;stroke-miterlimit:10;stroke-width:1.91px;}")), /*#__PURE__*/React.createElement("g", {
    id: "Chemical"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.23,
    y1: 1.5,
    x2: 16.77,
    y2: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.14,1.5v9.55L3.41,16.77v3.82A1.9,1.9,0,0,0,5.32,22.5H18.68a1.9,1.9,0,0,0,1.91-1.91V16.77l-5.73-5.72V1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.24,15.94c1.36.4,1.64,1.79,3.46,1.79,2.15,0,2.15-1.91,4.29-1.91s2.16,1.91,4.31,1.91c1.82,0,2.1-1.39,3.46-1.79"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.95,
    y1: 11.05,
    x2: 14.86,
    y2: 11.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.95,
    y1: 8.18,
    x2: 14.86,
    y2: 8.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.95,
    y1: 5.32,
    x2: 14.86,
    y2: 5.32
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTube);
export default __webpack_public_path__ + "static/media/tube.1381840ab2771f470e58735dda331a04.svg";
export { ForwardRef as ReactComponent };